import { Cookies } from 'react-cookie';
import CarouselMainSvg from '../shared/images/svgs/carousel-main.svg';
import userId from '../shared/helpers/userId';

export const generateUniqueId = () => {
  const timestamp = Date.now().toString(36); // Convert timestamp to base36
  const randomString = Math.random()
    .toString(36)
    .substring(2, 8); // Generate random string

  return timestamp + randomString;
};

export const getMissingNumbers = (array1, array2) => {
  const numericArray1 = array1.map(element => Number(element));
  const numericArray2 = array2.map(element => Number(element));

  const missingElements = [];

  numericArray1.forEach(element => {
    if (!numericArray2.includes(element)) {
      missingElements.push(element);
    }
  });

  return missingElements;
};

export const getDaysArrayByMonth = month => {
  let daysArray = [];
  let maxDay = 31;
  if (month == '02') {
    maxDay = 29;
  } else if (['04', '06', '09', '11'].includes(month)) {
    maxDay = 30;
  }

  for (let i = 1; i <= maxDay; i++) {
    let day = i <= 9 ? `0${i}` : i;
    let dayObj = { label: day, value: day };
    daysArray.push(dayObj);
  }

  return daysArray;
};

export const monthsArrayOptions = [
  { label: 'Jan', value: '01', ariaLabel: 'January' },
  { label: 'Feb', value: '02', ariaLabel: 'February' },
  { label: 'Mar', value: '03', ariaLabel: 'March' },
  { label: 'Apr', value: '04', ariaLabel: 'April' },
  { label: 'May', value: '05', ariaLabel: 'May' },
  { label: 'Jun', value: '06', ariaLabel: 'June' },
  { label: 'Jul', value: '07', ariaLabel: 'July' },
  { label: 'Aug', value: '08', ariaLabel: 'August' },
  { label: 'Sep', value: '09', ariaLabel: 'September' },
  { label: 'Oct', value: '10', ariaLabel: 'October' },
  { label: 'Nov', value: '11', ariaLabel: 'November' },
  { label: 'Dec', value: '12', ariaLabel: 'December' },
];

export const getYearArrayOptions = (minLimit = 20, maxLimit = 20) => {
  const date = new Date();
  let year = date.getFullYear();
  const yearArray = [];

  let pastYear = year - minLimit;
  let futureYear = parseInt(year) + maxLimit;

  for (let i = pastYear; i <= futureYear; i++) {
    let yearObj = { label: i, value: i };
    yearArray.push(yearObj);
  }

  return yearArray;
};

export const getTimeHour = () => {
  let timeArray = [];
  for (let i = 1; i <= 12; i++) {
    let time = i <= 9 ? `0${i}` : i;
    let timeObj = { label: time, value: time };
    timeArray.push(timeObj);
  }

  return timeArray;
};

export const getTimeMinute = () => {
  let timeArray = [];
  for (let i = 0; i <= 59; i++) {
    let time = i <= 9 ? `0${i}` : i;
    let timeObj = { label: time, value: time };
    timeArray.push(timeObj);
  }

  return timeArray;
};

export const timeMeridiem = [
  { label: 'AM', value: 'AM', ariaLabel: 'AM' },
  { label: 'PM', value: 'PM', ariaLabel: 'PM' },
]


export const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

export const setIsSessionExpiredCookie = () => {

  let baseDomain = '';
  const hostName = window?.location?.hostname;
  const hostNameSplit = hostName.split('.');
  const hostLength = hostNameSplit?.length;
  const hostTLD = hostNameSplit[hostNameSplit?.length - 1].split(':')[0].toLowerCase();

  if (hostTLD === 'com') {
    // ex: via-trm.com
    baseDomain = `.${hostNameSplit[hostLength - 2]}.${hostTLD}`;
  } else if (hostTLD === 'nz') {
    //ex: go.360international.ac.nz
    baseDomain = `.${hostNameSplit[hostLength - 3]}.${hostNameSplit[hostLength - 2]}.${hostTLD}`;
  }

  const cookies = new Cookies();
  cookies.set('is_session_expired', '1', { path: '/', sameSite: 'lax', domain: baseDomain });
}


export const getIsSessionExpired = () => {
  const cookies = new Cookies();
  return cookies.get('is_session_expired');
}

export const removeIsSessionExpiredCookie = () => {

  let baseDomain = '';
  const hostName = window?.location?.hostname;
  const hostNameSplit = hostName.split('.');
  const hostLength = hostNameSplit?.length;
  const hostTLD = hostNameSplit[hostNameSplit?.length - 1].split(':')[0].toLowerCase();

  if (hostTLD === 'com') {
    // ex: via-trm.com
    baseDomain = `.${hostNameSplit[hostLength - 2]}.${hostTLD}`;
  } else if (hostTLD === 'nz') {
    //ex: go.360international.ac.nz
    baseDomain = `.${hostNameSplit[hostLength - 3]}.${hostNameSplit[hostLength - 2]}.${hostTLD}`;
  }

  const cookies = new Cookies();
  cookies.remove('is_session_expired');
  cookies.remove('is_session_expired', { path: '/' });
  cookies.remove('is_session_expired', { path: '/', sameSite: 'lax', domain: baseDomain });
}


const hasProgramAccessPermission = (isAuthorized = false, programPremiumProgramFeatureAccess = false, clientProgramPremiumFeatureAccess = false) => {

  if(isAuthorized){
    return programPremiumProgramFeatureAccess; 
  }

  return clientProgramPremiumFeatureAccess; 

}


// export const defaultProgramImage = "https://via-default-images.s3.us-west-2.amazonaws.com/programs/program_large_program_background.jpg"; 
export const defaultProgramImage = CarouselMainSvg; 

export const hasProgramFeatureAccessPermission = (isAuthorized = false, programPremiumProgramFeatureAccess = false, clientProgramPremiumFeatureAccess = false, primaryClientAccountId = null, currentClientAccountId = null) => {
  const hasPremiumAccess = hasProgramAccessPermission(isAuthorized, programPremiumProgramFeatureAccess, clientProgramPremiumFeatureAccess); 

  // handling condition for unauthorized program
  if(primaryClientAccountId && currentClientAccountId){
    if(parseInt(primaryClientAccountId) !== parseInt(currentClientAccountId)){
      return {
        hasPremiumAccess: programPremiumProgramFeatureAccess,
        defaultProgramImage: defaultProgramImage
      }
    }
  }

  if(!userId){
    return {
      hasPremiumAccess: isAuthorized ? programPremiumProgramFeatureAccess : clientProgramPremiumFeatureAccess,
      defaultProgramImage
    }
  }

  return {
    hasPremiumAccess,
    defaultProgramImage
  }
}


